import type { IPermission } from '@condo/domain';
import { checkPermissions } from '@condo/domain';
import { useCurrentUserDetails } from './current-user.hook';

export function useHasPermissions() {
    const { user, isAdmin, isLoading } = useCurrentUserDetails();

    const hasPermission = (...requiredPermissions: IPermission[]): boolean => {
        if (isAdmin) return true;
        if (!user) return false;
        return checkPermissions(user.permissions, requiredPermissions);
    };

    return { hasPermission, isLoading };
}
